<div mat-dialog-title>
    Seleccionar grupo
  </div>
  <div mat-dialog-content>
    <mat-selection-list #shoes [multiple]="false">
        <mat-list-option *ngFor="let group of groups" (click)="selectGroup(group)" mat-dialog-close [selected] = "selectedId == group.id">
          {{group.description}}
        </mat-list-option>
      </mat-selection-list>
      
  
  </div>
  <!--div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cerrar</button>
  </div-->